module.exports = __webpack_public_path__ + "img/dick3-cover-1.03b5af52.jpg";